import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, clearSession } from "./api";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const applyCssTokens = useCallback((cfg) => {
    if (!cfg) return;
    const root = document.documentElement.style;
    if (cfg.primary_color) root.setProperty("--pxos-primary", cfg.primary_color);
    if (cfg.primary_light) root.setProperty("--pxos-primary-light", cfg.primary_light);
    if (cfg.primary_accent) root.setProperty("--pxos-accent", cfg.primary_accent);
    if (cfg.text_dark) root.setProperty("--pxos-text-dark", cfg.text_dark);
    if (cfg.surface_color) root.setProperty("--pxos-surface", cfg.surface_color);
    if (cfg.app_name) document.title = cfg.app_name;
  }, []);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      // Bug 20/50 · parallelize config + me() per ridurre "Caricamento…" iniziale.
      // Prima era serial (config → me) = 2 RTT bloccanti. Ora 1 RTT max.
      const hasToken = !!getToken();
      const [cfg, meResult] = await Promise.all([
        api.publicConfig(),
        hasToken ? api.me().catch(() => null) : Promise.resolve(null),
      ]);
      setConfig(cfg);
      applyCssTokens(cfg);
      if (hasToken) {
        if (meResult) setUser(meResult);
        else { setUser(null); clearSession(); }
      } else setUser(null);
    } finally { setLoading(false); }
  }, [applyCssTokens]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <Ctx.Provider value={{ config, user, loading, refresh, setUser }}>
      {children}
    </Ctx.Provider>
  );
}

export function useApp() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useApp must be inside AppProvider");
  return v;
}
